const agilityIcon = require("../assets/img/icon-agility.png");
const dockDivingIcon = require("../assets/img/icon-dockdiving.png");
const fastCatIcon = require("../assets/img/icon-fastcat.png");
const flyballIcon = require("../assets/img/icon-flyball.png");
const discIcon = require("../assets/img/icon-disc.png");

const accomplishmentYears = [
  {
    year: "2026",
    entries: [
      { names: "Jyn, Nimona, Asher", text: "Westminster Reg 1 Winner", icon: flyballIcon, sport: "Flyball", showOnHomepage: true },
      { names: "Cinco", text: "Purina Incredible Dog Challenge winner medium agility and weaves challenge.", homepageText: "Purina Incredible Dog Challenge winner", icon: agilityIcon, sport: "Agility", showOnHomepage: true },
      { names: "Cinco", text: "Senior Agility Open team member. 3rd SAO individual jumping, 2nd team agility.", homepageText: "Purina Incredible Dog Challenge winner", icon: agilityIcon, sport: "Agility", showOnHomepage: false },
      { names: "Cinco", text: "European Open team member. 2nd Place Round 1 and 4 at EO Tryouts.", homepageText: "Purina Incredible Dog Challenge winner", icon: agilityIcon, sport: "Agility", showOnHomepage: false },
      { names: "Nimona", text: "1st UKI DASH Triathlon.", homepageText: "1st UKI DASH Triathlon", icon: agilityIcon, sport: "Agility", showOnHomepage: true },
      { names: "Asher", text: "2nd UKI DASH Speedstakes", icon: agilityIcon, sport: "Agility" },
      { names: "Nimona", text: "Updif: 4th overall 7Up, 2nd Midi division 7Up, 2nd Midi division Boom, top 4% Midi.", homepageText: "Updif: 4th overall 7Up, 2nd Midi division 7Up, 2nd Midi division Boom, top 4% Midi.", icon: discIcon, sport: "Disc", showOnHomepage: false },
      { names: "Decoy", text: "New flyball PB 3.64", homepageText: "New flyball PB 3.64", icon: flyballIcon, sport: "Flyball", showOnHomepage: true },
      { names: "Vox", text: "Body Armour state games winner dock dogs", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Vox", text: "New dock diving PB 25'2", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Rumi", text: "Dock diving debut, pb of 21'10", homepageText: "Dock diving debut, PB 21'10", icon: dockDivingIcon, sport: "Dock Diving", showOnHomepage: true },
      { names: "Zinnia", text: "Dock diving debut, pb of 18'3", icon: dockDivingIcon, sport: "Dock Diving" }
    ]
  },
  {
    year: "2025",
    entries: [
      { names: "Venus", text: "2nd Place Reg 1 team at Canam", icon: flyballIcon, sport: "Flyball" },
      { names: "Cinco", text: "Team USA Senior AWC team alternate, national podiums at ISC champs, Cynosports, and US Open.", icon: agilityIcon, sport: "Agility" },
      { names: "Nimona", text: "AKC Diving Dogs Lap Dog Winner", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Nimona", text: "Top 10 for all three NADD events", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Nimona", text: "New flyball PB 3.73", icon: flyballIcon, sport: "Flyball" },
      { names: "Vox", text: "New flyball PB 3.71", icon: flyballIcon, sport: "Flyball" },
      { names: "Vox", text: "New dock diving PB 25ft", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Boone", text: "Flyball team pb of 16.01", icon: flyballIcon, sport: "Flyball" },
      { names: "Jyn", text: "28mph FAST CAT pb", icon: fastCatIcon, sport: "Fast CAT" },
      { names: "Seeker", text: "ICE Rookie 1st place", icon: agilityIcon, sport: "Agility" },
      { names: "Shea", text: "1st Place Reg 2 team at Canam", icon: flyballIcon, sport: "Flyball" },
      { names: "Shea", text: "New flyball pb 3.8", icon: flyballIcon, sport: "Flyball" },
      { names: "Decoy", text: "New flyball pb 3.67", icon: flyballIcon, sport: "Flyball" }
    ]
  },
  {
    year: "2024",
    entries: [
      { names: "Venus", text: "New dock diving pb 26ft 10in", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Cinco", text: "Regional agility podiums", icon: agilityIcon, sport: "Agility" },
      { names: "Nimona", text: "NADD Nationals Hydrodash 1st, AR 2nd", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Nimona", text: "NADD #1 AR & #2 Distance Lap dog", icon: dockDivingIcon, sport: "Dock Diving" },
      { names: "Nimona", text: "Skyhoundz Extreme Distance 2nd & MicroDog Sport 3rd", icon: discIcon, sport: "Disc" },
      { names: "Nimona", text: "New flyball pb 3.80", icon: flyballIcon, sport: "Flyball" },
      { names: "Vox", text: "New flyball PB 3.80", icon: flyballIcon, sport: "Flyball" },
      { names: "Boone", text: "2nd Place Canam team, new flyball pb 3.99", icon: flyballIcon, sport: "Flyball" },
      { names: "Jyn", text: "new flyball pb 3.79", icon: flyballIcon, sport: "Flyball" }
    ]
  }
];

export default accomplishmentYears;
